import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Button, Row, Col, Table, Input, Label } from "reactstrap";
import axios from "axios";
import ExportJsonExcel from "js-export-excel";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";

// Las columnas siguen los 8 bloques del formato del cliente. Cada una sale de lo
// que se capturo en compras o en ventas; ninguna se teclea aqui. Lo que nadie
// capturo en los tracking sale solo del pedido, la OC, el embarque o el modelo.
//   n = numero · m = importe · g = a que bloque pertenece
const COLS = [
  { k: "proveedor", h: "PROVEEDOR", g: "Informacion proveedor" },
  { k: "oc", h: "PO", g: "Informacion proveedor" },
  { k: "pi", h: "PI", g: "Informacion proveedor" },
  { k: "fechaPi", h: "FECHA PI", g: "Informacion proveedor" },
  { k: "paisOrigen", h: "PAIS ORIGEN", g: "Informacion proveedor" },

  { k: "cliente", h: "CLIENTE", g: "Informacion cliente" },
  { k: "vendedor", h: "VENDEDOR", g: "Informacion cliente" },
  { k: "comprador", h: "COMPRADOR", g: "Informacion cliente" },
  { k: "depto", h: "DEPARTAMENTO", g: "Informacion cliente" },
  { k: "modelo", h: "MODELO", g: "Informacion cliente" },
  { k: "pedidoCliente", h: "PEDIDO CLIENTE", g: "Informacion cliente" },
  { k: "cantidad", h: "CANTIDAD PEDIDO", n: true, g: "Informacion cliente" },
  { k: "marcaCliente", h: "MARCA CLIENTE", g: "Informacion cliente" },
  { k: "descripcion", h: "DESCRIPCION", g: "Informacion cliente" },

  { k: "fechaFob", h: "FOB ETD AGREED", g: "Fechas de recibo y entrega" },
  { k: "crd", h: "CRD", g: "Fechas de recibo y entrega" },
  { k: "cancelacionOC", h: "FECHA CANCELACION", g: "Fechas de recibo y entrega" },
  { k: "fichasControl", h: "FICHAS CONTROL", g: "Fechas de recibo y entrega" },

  { k: "auditoria", h: "AUDITORIA", g: "Confirmacion y citas" },
  { k: "fechaConfirmacion", h: "FECHA CONFIRMACION", g: "Confirmacion y citas" },
  { k: "cita", h: "CITA", g: "Confirmacion y citas" },
  { k: "ampliacion", h: "AMPLIACION", g: "Confirmacion y citas" },

  { k: "qtyOriginal", h: "CANTIDAD PO ORIGINAL", n: true, g: "Costos y cantidades" },
  { k: "qtyOC", h: "CANTIDAD PO PROVEEDOR", n: true, g: "Costos y cantidades" },
  { k: "qtyPL", h: "CANTIDAD PL", n: true, g: "Costos y cantidades" },
  { k: "difOCvsPL", h: "DIF OC VS PL", n: true, g: "Costos y cantidades" },
  { k: "costoRmb", h: "COSTO RMB / DLLS", g: "Costos y cantidades" },
  { k: "costoUSD", h: "COSTO USD", m: true, g: "Costos y cantidades" },
  { k: "montoTtl", h: "MONTO TTL", m: true, g: "Costos y cantidades" },
  { k: "montoReal", h: "MONTO REAL", m: true, g: "Costos y cantidades" },
  { k: "costoCliente", h: "COSTO CLIENTE", m: true, g: "Costos y cantidades" },
  { k: "pdv", h: "PDV", g: "Costos y cantidades" },

  { k: "tallaProp", h: "PROPORCION TALLA", g: "Detalle de prenda" },
  { k: "colorProp", h: "PROPORCION COLOR", g: "Detalle de prenda" },
  { k: "monarch", h: "MONARCH Y MARCA", g: "Detalle de prenda" },
  { k: "etiquetaPrecio", h: "ETIQUETA PRECIO", g: "Detalle de prenda" },

  { k: "labDips", h: "LAB DIPS", g: "Aprobaciones proveedor" },
  { k: "fit", h: "FIT", g: "Aprobaciones proveedor" },
  { k: "ppSample", h: "PP SAMPLE", g: "Aprobaciones proveedor" },
  { k: "shippingSample", h: "SHIPPING SAMPLE", g: "Aprobaciones proveedor" },
  { k: "paqueteria", h: "PAQUETERIA", g: "Aprobaciones proveedor" },
  { k: "aprobacionProduccion", h: "APROBACION PRODUCCION", g: "Aprobaciones proveedor" },
  { k: "contenedor", h: "CONTENEDOR", g: "Aprobaciones proveedor" },
  { k: "eta", h: "ETA", g: "Aprobaciones proveedor" },
  { k: "comentarios", h: "COMENTARIOS", g: "Aprobaciones proveedor" },

  { k: "fechaEntregaCliente", h: "FECHA ENTREGA CLIENTE", g: "Entregas" },
  { k: "qtyEntregada", h: "CANTIDAD ENTREGADA", n: true, g: "Entregas" },
  { k: "sobrante", h: "SOBRANTE", n: true, g: "Entregas" },
  { k: "sobranteFinal", h: "SOBRANTE FINAL", n: true, g: "Entregas" },
  { k: "costoStock", h: "COSTO STOCK", m: true, g: "Entregas" },
  { k: "statusEtdProveedor", h: "STATUS ETD PROVEEDOR", g: "Entregas" },
  { k: "comentSemanal", h: "COMENT SEMANAL", g: "Entregas" },
  { k: "statusEntrega", h: "STATUS ENTREGA", g: "Entregas" },
  { k: "estatus", h: "ESTATUS", g: "Entregas" },
];

const TOTALIZA = ["cantidad", "qtyOriginal", "qtyOC", "qtyPL", "difOCvsPL", "qtyEntregada", "sobrante", "sobranteFinal", "montoTtl", "montoReal"];
const ANCHO = 130;
const fmtN = (v) => new Intl.NumberFormat("es-MX").format(v || 0);
const fmtM = (v) => new Intl.NumberFormat("es-MX", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(v || 0);

function SeguimientoGeneral() {
  const { user } = useContext(AuthContext);
  const URL_SEGUIMIENTOS = process.env.REACT_APP_URL_SEGUIMIENTOS;
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  // un filtro por columna, guardado por su clave
  const [filtros, setFiltros] = useState({});
  // desde ListadoPedidos se abre con ?pedido=NN: solo los renglones de ese pedido
  const [pedidoFijo, setPedidoFijo] = useState(() => new URLSearchParams(window.location.search).get("pedido") || "");

  useEffect(() => {
    axios.get(`${URL_SEGUIMIENTOS}General`, { headers })
      .then((res) => { setFilas(res.data || []); setCargando(false); })
      .catch(() => { setCargando(false); Swal.fire({ icon: "error", title: "Ups...", text: "No se pudo cargar el seguimiento" }); });
  }, []); // eslint-disable-line

  // Columnas con pocos valores distintos se filtran con lista; las demas por texto.
  const opciones = useMemo(() => {
    const o = {};
    COLS.forEach((c) => {
      if (c.n || c.m) return;
      const vals = [...new Set(filas.map((f) => (f[c.k] ?? "").toString().trim()).filter(Boolean))];
      if (vals.length > 0 && vals.length <= 15) o[c.k] = vals.sort();
    });
    return o;
  }, [filas]);

  const pon = (k, v) => setFiltros((p) => ({ ...p, [k]: v }));
  const limpiar = () => { setFiltros({}); setBusqueda(""); };
  const activos = Object.values(filtros).filter(Boolean).length;

  const filtradas = filas.filter((f) => {
    if (pedidoFijo && String(f.pedidoCliente) !== pedidoFijo) return false;
    for (const c of COLS) {
      const v = filtros[c.k];
      if (!v) continue;
      const celda = (f[c.k] ?? "").toString().toLowerCase();
      if (opciones[c.k]) { if (celda !== v.toLowerCase()) return false; }
      else if (!celda.includes(v.toLowerCase())) return false;
    }
    if (!busqueda) return true;
    return COLS.some((c) => (f[c.k] ?? "").toString().toLowerCase().includes(busqueda.toLowerCase()));
  });

  const tot = (k) => filtradas.reduce((s, f) => s + (parseFloat(f[k]) || 0), 0);

  const exportar = () => {
    new ExportJsonExcel({
      fileName: "SeguimientoGeneral",
      datas: [{
        sheetData: filtradas.map((f) => {
          const o = {};
          COLS.forEach((c) => { o[c.h] = f[c.k]; });
          return o;
        }),
        sheetName: "General",
        sheetFilter: COLS.map((c) => c.h),
        sheetHeader: COLS.map((c) => c.h),
      }],
    }).saveExcel();
  };

  // bloques del encabezado superior, con su ancho en columnas
  const bloques = [];
  COLS.forEach((c) => {
    const ult = bloques[bloques.length - 1];
    if (ult && ult.g === c.g) ult.n += 1;
    else bloques.push({ g: c.g, n: 1 });
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_reportes ? (
        <div className="card container col-12">
          <Row className="mb-2">
            <Col md={4}>
              <Button href={pedidoFijo ? "/ListadoPedidos" : "/MenuOperacion"} className="btn btn-danger" size="sm">Regresar</Button>{" "}
              <Button className="btn btn-primary" size="sm" onClick={exportar}>Excel</Button>{" "}
              <Button color="secondary" size="sm" onClick={limpiar}>Limpiar filtros</Button>{" "}
              {pedidoFijo ? (
                <Button color="info" size="sm" onClick={() => setPedidoFijo("")}>Ver todos los pedidos</Button>
              ) : null}
            </Col>
            <Col md={5}>
              <Label>Buscar en todo el reporte</Label>
              <Input bsSize="sm" type="text" value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
            </Col>
            <Col md={3} style={{ display: "flex", alignItems: "flex-end" }}>
              <p style={{ margin: 0, color: "#64748b", fontSize: "0.8rem" }}>
                {filtradas.length} de {filas.length} renglones
                {activos ? ` · ${activos} filtro(s) activos` : ""}
              </p>
            </Col>
          </Row>

          <h3 align="center">Seguimiento General{pedidoFijo ? ` · Pedido ${pedidoFijo}` : ""}</h3>
          {cargando ? (<h6 align="center">Cargando...</h6>) : (
            <div style={{ width: "100%", overflowX: "auto" }}>
              <Table size="sm" striped bordered style={{ whiteSpace: "nowrap", minWidth: COLS.length * ANCHO }}>
                <thead>
                  <tr>
                    {bloques.map((b, i) => (
                      <th key={i} colSpan={b.n} className="tituloTabla"
                        style={{ textAlign: "center", background: i % 2 ? "#f1f5f9" : "#e2e8f0" }}>
                        {b.g}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {COLS.map((c) => (
                      <th key={c.k} className="tituloTabla" style={{ minWidth: ANCHO }}>{c.h}</th>
                    ))}
                  </tr>
                  <tr>
                    {COLS.map((c) => (
                      <th key={c.k} style={{ minWidth: ANCHO, padding: 2 }}>
                        {opciones[c.k] ? (
                          <Input bsSize="sm" type="select" value={filtros[c.k] || ""}
                            onChange={(e) => pon(c.k, e.target.value)}>
                            <option value="">Todos</option>
                            {opciones[c.k].map((v) => (<option key={v} value={v}>{v}</option>))}
                          </Input>
                        ) : (
                          <Input bsSize="sm" type="text" placeholder="filtrar"
                            value={filtros[c.k] || ""} onChange={(e) => pon(c.k, e.target.value)} />
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtradas.map((f, idx) => (
                    <tr key={f.idArticulosOC || idx}>
                      {COLS.map((c) => (
                        <td key={c.k} style={c.n || c.m ? { textAlign: "right" } : undefined}>
                          {c.m ? fmtM(f[c.k]) : c.n ? fmtN(f[c.k]) : f[c.k]}
                        </td>
                      ))}
                    </tr>
                  ))}
                  {filtradas.length === 0 ? (
                    <tr><td colSpan={COLS.length} align="center" style={{ color: "#94a3b8" }}>
                      No hay renglones con esos filtros.
                    </td></tr>
                  ) : null}
                  <tr>
                    {COLS.map((c, i) => (
                      <td key={c.k} style={{ fontWeight: 700, textAlign: c.n || c.m ? "right" : "left", background: "#f8fafc" }}>
                        {i === 0 ? `${filtradas.length} renglones`
                          : TOTALIZA.includes(c.k) ? (c.m ? fmtM(tot(c.k)) : fmtN(tot(c.k)))
                          : ""}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default SeguimientoGeneral;
